import { useEffect } from 'react'
import { useParams, useLocation, useNavigate, Outlet } from 'react-router-dom'

const SUPPORTED = ['en', 'es', 'pt']

function getStoredPreference() {
  try {
    const stored = localStorage.getItem('i18nextLng')
    if (!stored) return null
    const code = stored.slice(0, 2)
    return SUPPORTED.includes(code) ? code : null
  } catch {
    return null
  }
}

export default function LanguageRouter() {
  const { lang } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (lang) {
      if (SUPPORTED.includes(lang)) return
      const rest = pathname.replace(/^\/[a-z]{2}/, '')
      navigate(`/en${rest || '/'}`, { replace: true })
      return
    }
    const pref = getStoredPreference()
    if (pref && pref !== 'en') {
      navigate(`/${pref}${pathname}`, { replace: true })
    }
  }, [lang, pathname, navigate])

  return <Outlet />
}